import styled, { css } from "styled-components";

export const hoverContentStyles = css`
  .ref {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  .blocked {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  .disabled {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  .valueChanged {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
    
    .valueChangedOldValue {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
    }

    .valueChangedNewValue {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
    }
  }

  .textbox {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  .refMultipleContainer {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  .date {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }
`;

interface IRefContainer {
  multiple?: boolean;
}

export const RefContainer = styled.div<IRefContainer>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .ref {
    width: auto;
    min-height: 30px;
    display: flex;
    align-items: center;
    padding: 2px 8px 2px 4px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    background-color: ${({ theme }) => theme.colors.surface.surface};

    .refIcon {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    }

    .refId {
      font-size: 12px;
      font-weight: 600;
      line-height: normal;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
      margin-left: 2px;
    }

    .refValue {
      font-size: 12px;
      font-weight: 600;
      line-height: normal;
      color: ${({ theme }) => theme.colors.surface.onSurface};
      margin-left: 4px;
    }

    .refIconFooter {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    }
  }

  .refMultipleContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 8px 2px 4px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    background-color: ${({ theme }) => theme.colors.surface.surface};

    .refMultiple {
      display: flex;
      align-items: center;
      
      &:not(:first-child) {
        margin-left: -4px;
      }
    }

    .refMore {
      font-size: 12px;
      font-weight: 600;
      line-height: normal;
      color: ${({ theme }) => theme.colors.surface.onSurface};
      margin-left: 6px;
    }
  }

  .tooltipContent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .blocked {
    background-color: ${({ theme }) => theme.colors.surface.surfaceContainer};

    .refIcon {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder} !important;
    }

    .refId {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    }

    .refValue {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    }
  }

  .disabled {
    background-color: ${({ theme }) => theme.colors.surface.surfaceContainer};

    .refIcon {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder} !important;
    }

    .refId {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    }

    .refValue {
      text-decoration: line-through;
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    }
  }

  .danger {
    &.ref {
      border: 1px solid ${({ theme }) => theme.colors.danger.danger};
    }

    .refIcon {
      color: ${({ theme }) => theme.colors.danger.danger} !important;
    }
    
    .refIconFooter {
      color: ${({ theme }) => theme.colors.danger.danger} !important;
    }
  }

  .success {
    .refIconFooter {
      color: ${({ theme }) => theme.colors.success.success} !important;
    }
  }

  ${({ multiple }) => multiple && css`
    flex-direction: row;
    align-items: center;

    .refShowLimit {
      margin-left: 4px;

      .refValueShowLimit {
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
      }
    }
  `}
`;

export const ValueChangedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .valueChanged {
    width: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 4px;
    padding: 2px 8px 2px 4px;
    background-color: ${({ theme }) => theme.colors.surface.surface};

    .valueChangedLabel {
      font-size: 12px;
      font-weight: 400;
      line-height: normal;
      color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant};
    }

    .valueChangedOldValue {
      margin-left: 6px;
      padding: 2px 4px;
      border-radius: 4px;
      background-color: ${({ theme }) => theme.colors.secondary.secondary};

      font-size: 12px;
      font-weight: 600;
      line-height: normal;
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    }

    .valueChangedIcon {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    }

    .valueChangedNewValue {
      padding: 2px 4px;
      border-radius: 4px;
      background-color: ${({ theme }) => theme.colors.secondary.secondary};

      font-size: 12px;
      font-weight: 600;
      line-height: normal;
      color: ${({ theme }) => theme.colors.secondary.onSecondary};
    }

    .label-disabled {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
      text-decoration: line-through;
    }

    .label-warning {
      color: ${({ theme }) => theme.colors.warning.warning};
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.warning.warningContainer}, ${theme.colors.surface.surface})`};
      text-decoration: none;
    }

    .label-success {
      color: ${({ theme }) => theme.colors.success.success};
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.success.successContainer}, ${theme.colors.surface.surface})`};
    }

    .label-danger {
      color: ${({ theme }) => theme.colors.danger.danger};
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.danger.dangerContainer}, ${theme.colors.surface.surface})`};
      text-decoration: none;
    }

    .only-new-value {
      margin-left: -4px;
    }
  }
`;

export const ImagesContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .images {
    position: relative;
    width: 64px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    overflow: hidden;

    &+.images {
      margin-left: 4px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .imagesMore {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #00000080;

      font-size: 14px;
      font-weight: 600;
      line-height: normal;
      color: ${({ theme }) => theme.colors.surface.surface};
    }
  }
`;

export const TextboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .textbox {
    width: auto;
    display: flex;
    align-items: center;
    padding: 2px 8px 2px 4px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    background-color: ${({ theme }) => theme.colors.secondary.secondary};

    .textboxIcon {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    }

    .textboxLabel {
      font-size: 12px;
      font-weight: 600;
      line-height: normal;
      color: ${({ theme }) => theme.colors.secondary.onSecondary};
      margin-left: 4px;
    }

    .textboxValue {
      font-size: 12px;
      font-weight: 400;
      line-height: normal;
      color: ${({ theme }) => theme.colors.secondary.onSecondary};
    }

    .textboxValueEmpty {
      color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    }
  }

  .label-danger {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.danger.dangerContainer}, ${theme.colors.surface.surface})`};

    .textboxIcon {
      color: ${({ theme }) => theme.colors.danger.danger} !important;
    }

    .textboxLabel {
      color: ${({ theme }) => theme.colors.danger.danger};
    }
  }

  .success {
    &.textbox {
      border: none;
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.success.successContainer}, ${theme.colors.surface.surface})`};
    }

    .textboxIcon {
      color: ${({ theme }) => theme.colors.success.success} !important;
    }

    .textboxLabel {
      color: ${({ theme }) => theme.colors.success.success};
    }
  }
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .date {
    width: auto;
    display: flex;
    align-items: center;
    padding: 2px 8px 2px 4px;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.secondary.secondary};

    .dateIcon {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    }

    .dateLabel {
      font-size: 12px;
      font-weight: 400;
      line-height: normal;
      color: ${({ theme }) => theme.colors.surface.onSurface};
      margin-left: 2px;
    }
  }

  .danger {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.danger.dangerContainer}, ${theme.colors.surface.surface})`};

    .dateIcon {
      color: ${({ theme }) => theme.colors.danger.danger} !important;
    }

    .dateLabel {
      color: ${({ theme }) => theme.colors.danger.danger};
    }
  }
`;
